import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from './auth-state.service';

const DEFAULT_POST_LOGIN_PATH = '/messages';

function readRequestedBrowserPath(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const requestedPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return requestedPath === '/' ? null : requestedPath;
}

export const appEntryGuard: CanActivateFn = async (_route, _state) => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  await authState.initialize();

  if (authState.isAuthenticated()) {
    return router.parseUrl(authState.consumePostLoginPath() ?? DEFAULT_POST_LOGIN_PATH);
  }

  await authState.login(DEFAULT_POST_LOGIN_PATH, { preserveExisting: true });
  return false;
};

export const authenticatedGuard: CanActivateFn = async (_route, state) => {
  const authState = inject(AuthStateService);

  await authState.initialize();

  if (authState.isAuthenticated()) {
    return true;
  }

  await authState.login(readRequestedBrowserPath() ?? state.url);
  return false;
};